import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import {
    useClub,
    useDefaultTopic,
    useDictionary,
    useMediaConfig,
    useBasePath,
} from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';
import { QUERY_PARAMS } from 'bdvp-common/src/utils/constants';


const A = styled.a`
    display: inline-block;
`;

const Image = styled.img`
    height: 38px;
    margin: ${({ theme }) => `0 ${theme?.pageTemplate?.paddingLeftRight?.xs};`};
    vertical-align: middle;
    ${media.mdmin`
        margin: ${({ theme }) => `0 ${theme?.pageTemplate?.paddingLeftRight?.md};`};
    `}
    ${media.lgmin`
        margin: ${({ theme }) => `0 ${theme?.pageTemplate?.paddingLeftRight?.lg};`};
    `}
`;

const Branding = (props) => {

    const { className } = props;
    const location = useLocation();
    const club = useClub();
    const config =  useMediaConfig();
    const defaultTopic = useDefaultTopic();
    const {
        film_room_home_page = 'Film Room Home Page',
    } = useDictionary();
    const basePath = useBasePath();
    const history = useHistory();

    const urlParams = new URLSearchParams(location.search);
    const appPath = location?.pathname;
    const topicFromParam = urlParams.get(QUERY_PARAMS.topicId); // Check if we have a query param
    const isTopicPage = appPath.includes('/topic'); // Check if we are under a topic page
    const pageHasTopic = isTopicPage || topicFromParam;

    // Build topicId from url or from query params
    let topicId;

    if (pageHasTopic) {

        const topicFromPathname = isTopicPage && appPath.split('/topic/')[1];
        topicId = topicFromPathname || topicFromParam;

    }

    // Check if we are under a default topic page
    const isDefaultTopic = appPath === `/`;

    if (!topicId && isDefaultTopic) {

        topicId = defaultTopic;

    }

    const {
        subnavLogo: sponsorshipLogoAttrs,
        excludedTeams = [],
        excludedTopics = [],
        enabled: isSponsorshipEnabled,
    } = config?.sponsorship || {};

    const productLogoAttrs = config?.logo || {};

    // Check if we should show the sponsor logo
    const shouldShowSponsorship = (isSponsorshipEnabled || false) && !(
        excludedTeams.some((team) => team === club)
        || excludedTopics.some((topic) => topic === topicId)
    );

    const logoAttr = shouldShowSponsorship ? sponsorshipLogoAttrs : productLogoAttrs;
    const handleClick = useCallback((e) => {

        e.preventDefault();
        Tracking.trackFilmRoomLogoClick();
        history.push('/');

    }, [history]);

    return (
        <A
            aria-label={film_room_home_page}
            onClick={handleClick}
            className={className}
            href={basePath}
        >
            <Image {...logoAttr} />
        </A>
    );

};

export default Branding;
